import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PanelWidget } from './panel/panel.component';
import { SharedModule } from '../../shared.module';
// import { PageLayoutWidget } from './page-layout/page-layout.component';
import { HeaderWidget } from './header/header.component';
import { BpaExternalModule } from '../../../bpa_client_src/app/bpa-external.module';
import { AlertBoxWidget } from './alert-box/alert-box.component';
import { DashboardCardWidget } from './dashboard/dashboard-card.component';
import { FormPageButtonBlockWidget } from './form-page-button-block/form-page-button-block.component';
import { FormPageLayoutWidget } from './form-page-layout/form-page-layout.component';
import { FormPageWidget } from './form-page/form-page.component';
import { LabelInputPairWidget } from './label-input-pair/label-input-pair.component';
import { LabelSelectPairWidget } from './label-select-pair/label-select-pair.component';
import { LabelTextPairWidget } from './label-text-pair/label-text-pair.component';
import { LargePageLayoutWidget } from './large-page-layout/large-page-layout.component';
import { LoginPageLayoutWidget } from './login-page-layout/login-page-layout.component';
import { ModalWidget } from './modal/modal.component';
import { PageLayoutWidget } from './page-layout/page-layout.component';
import { DurationFormatterPipe } from './pipe-duration/duration-formatter.pipe';
// import { PageLayoutModule } from './page-layout/page-layout.module.backup';

@NgModule({
  imports: [
    SharedModule,
    BpaExternalModule,
  ],
  declarations: [
    AlertBoxWidget,
    DashboardCardWidget,
    // FileUploadComponent,
    FormPageWidget,
    FormPageButtonBlockWidget,
    FormPageLayoutWidget,
    HeaderWidget,
    LabelInputPairWidget,
    LabelSelectPairWidget,
    LabelTextPairWidget,
    // LanguageComponent,
    LargePageLayoutWidget,
    LoginPageLayoutWidget,
    ModalWidget,
    PageLayoutWidget,
    PanelWidget,
    DurationFormatterPipe,
    // UploadUsersComponent
  ],
  exports: [
    AlertBoxWidget,
    DashboardCardWidget,
    // FileUploadComponent,
    FormPageWidget,
    FormPageButtonBlockWidget,
    FormPageLayoutWidget,
    HeaderWidget,
    LabelInputPairWidget,
    LabelSelectPairWidget,
    LabelTextPairWidget,
    // LanguageComponent,
    LargePageLayoutWidget,
    LoginPageLayoutWidget,
    ModalWidget,
    PageLayoutWidget,
    PanelWidget,
    DurationFormatterPipe,
    // PageLayoutModule
    // UploadUsersComponent,
  ]
})
export class AppWidgetModule {}
